// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".admin-dashboard[data-v-3a04df30]{padding:0 20px}.admin-dashboard .tabs[data-v-3a04df30]{display:flex;flex-direction:row;align-items:center;justify-content:flex-start;border-bottom:1px solid var(--q4s-neutral-200);height:50px;overflow-x:auto;overflow-y:hidden}.admin-dashboard .tabs .tab[data-v-3a04df30]{margin-right:10px}.admin-dashboard[data-v-3a04df30]  .highlighted-row{background-color:var(--q4s-primary-200);transition:background-color .5s}", ""]);
// Exports
module.exports = exports;
